import { graphql, Link, useStaticQuery } from "gatsby"
import { FlagsWrapper } from "./Flags.styles"
import Img from "gatsby-image"
import React from "react"

const Flags = ({ flagCode }) => {
  const data = useStaticQuery(graphql`
    {
      allFile(filter: {relativeDirectory: {eq: "country_report/country_flags"}}) {
        edges {
          node {
            id
            name
            childImageSharp {
              fixed(width: 30, height: 30, cropFocus: CENTER) {
                ...GatsbyImageSharpFixed
              }
            }
          }
        }
      }
      statamic {
        entries(collection: "country_reports", sort: "country_name asc", limit: 500) {
          data {
            id
            slug
            ... on Statamic_Entry_CountryReports_CountryReport {
              country_name
              country_flag
            }
          }
        }
      }
    }
  `)
  const countryReports =
    (data && data.statamic && data.statamic.entries && data.statamic.entries.data) || []
  const images = (data.allFile && data.allFile.edges) || []

  const flagOf = (report) =>
    Array.isArray(report.country_flag) ? report.country_flag[0] : report.country_flag

  const fixedFor = (flagName) => {
    if (!flagName) return null
    const match = images.find((image) => image.node.name === flagName)
    return (match && match.node.childImageSharp && match.node.childImageSharp.fixed) || null
  }

  function ShowList() {
    const toggle = document.getElementById('flags-container');
    const toggle2 = document.getElementById('dropdown-selector');
    if (toggle.classList.contains('hide-list')) {
      toggle.classList.remove('hide-list')
      toggle.classList.add('show-list')
      toggle2.classList.add('arrow-up');
    }
    else if (toggle.classList.contains('show-list')) {
      toggle.classList.remove('show-list')
      toggle.classList.add('hide-list')
      toggle2.classList.remove('arrow-up');
    }
  }

  return (
    <FlagsWrapper className="secondary-blue-3-background mb-3">

      {countryReports.map((report) => {
        const flagName = flagOf(report)
        if (flagName !== flagCode) return null
        const firstImage = fixedFor(flagName)
        if (!firstImage) return null
        return (
          <div key={report.id} className="d-inline-block" id="dropdown-selector" onClick={ShowList}>
            <Img fixed={firstImage} className="flag-img rounded-circle d-inline-block"
                 alt={`${report.country_name} Flag`} />
            <div className="country-name d-inline-block ml-3">
              {report.country_name}
            </div>
          </div>
        )
      })}
      <div className="white-background py-4 pl-3 pr-4 hide-list" id="flags-container">
        <div id="flags-container-inner">
          {countryReports.map((report) => {
            const flagName = flagOf(report)
            if (!flagName || flagName === flagCode) return null
            const fixed = fixedFor(flagName)
            if (!fixed || !report.slug) return null
            return (
              <Link
                key={report.id}
                className="flag-link"
                to={`/country-report/${report.slug}/`}
                target="_blank"
              >
                <div className="py-1">
                  <Img fixed={fixed} className="flag-img rounded-circle d-inline-block ml-3"
                       alt={`${report.country_name} Flag`} />
                  <div className="country-name d-inline-block ml-3">
                    {report.country_name}
                  </div>
                </div>
              </Link>
            )
          })}
        </div>
      </div>
    </FlagsWrapper>
  )
}

export default Flags
